import React, { useEffect, useState } from "react";
import { Popover, PopoverBody } from "reactstrap";

interface Props {
  inputRef: React.RefObject<HTMLInputElement>;
}

export const ErrorDisplay = ({ inputRef }: Props) => {
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    const checkFocus = () => {
      setIsFocused(document.activeElement === inputRef.current);
    };
    checkFocus();
    inputRef.current?.addEventListener("focus", checkFocus);
    inputRef.current?.addEventListener("blur", checkFocus);
    return () => {
      inputRef.current?.removeEventListener("focus", checkFocus);
      inputRef.current?.removeEventListener("blur", checkFocus);
    };
  }, [inputRef.current]);

  if (!inputRef.current?.classList.contains("is-invalid")) return null;
  return (
    <>
      <Popover target={inputRef} isOpen={isFocused} placement="bottom">
        <PopoverBody className="text-align-center ">
          <strong className="text-danger">Error!</strong>
          <br />
          <span>
            This value is outside the range allowed by the calculations.
          </span>
        </PopoverBody>
      </Popover>
    </>
  );
};
